export default [
  {
    path: '/main/offsetbyplate',
    meta: {
      tag: 'offset_plate',
      name: 'Offset - Ajuste por placa/equipamento',
      breadcrumb: 'Offset - Ajuste por placa/equipamento'
    },
    component: () => import(/* webpackChunkName: "offset_plate" */ '@/views/main/settings/parameters/offsetbyplate/Index.vue'),
    children: [
      {
        path: '',
        name: 'offsetbyplate',
        meta: {
          tag: 'offset_plate',
          name: 'Offset - Ajuste por placa/equipamento',
          menu: 'settings'
        },
        component: () => import(/* webpackChunkName: "offset_plate" */ '@/views/main/settings/parameters/offsetbyplate/List.vue'),
      }
    ]
  }
]